var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shouldDisplayButton)?_c('AppTooltip',{attrs:{"text":_vm.tooltipText,"placement":_vm.tooltipPlacement}},[_c('TopBarButtonIcon',{attrs:{"button-icon":_vm.backButtonIcon,"size":_vm.backButtonSize,"button-style":_vm.backButtonStyle},on:{"button-click":_vm.navigationHistoryBack}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }